/**
 * Botón flotante de cesta.
 *
 * Escucha los cambios del carrito y aparece cuando deja de estar vacío. La
 * cuenta se relee del servidor en lugar de llevarse en el cliente: entre
 * pestañas, con el botón atrás o si otro script toca el carrito, un contador
 * local se desincroniza y muestra un número falso justo donde más confianza
 * hace falta.
 */

const fab = document.querySelector('[data-cart-fab]');

if (fab) {
  const bubble = fab.querySelector('[data-fab-count]');
  const label = fab.querySelector('[data-fab-label]');
  const root = () => window.Shopify?.routes?.root || '/';

  let current = Number(fab.dataset.count || 0);

  function render(count) {
    if (count === current) return;

    const eraCero = current === 0;
    current = count;
    fab.dataset.count = String(count);

    if (count === 0) {
      fab.hidden = true;
      return;
    }

    if (bubble) bubble.textContent = String(count);
    if (label) label.textContent = `${count} artículos en la cesta`;

    if (eraCero) {
      // Primera pieza: entra el botón entero.
      fab.hidden = false;
      fab.classList.remove('is-entering');
      // Fuerza reflow para que la animación vuelva a dispararse si se repite.
      void fab.offsetWidth;
      fab.classList.add('is-entering');

      // Se retira al terminar para que no bloquee la transición de posición
      // que usa la convivencia con la barra fija de compra.
      fab.addEventListener(
        'animationend',
        () => fab.classList.remove('is-entering'),
        { once: true }
      );
      return;
    }

    // Ya estaba visible: sólo late la burbuja.
    if (!bubble) return;
    bubble.classList.remove('is-bumped');
    void bubble.offsetWidth;
    bubble.classList.add('is-bumped');
  }

  async function sync(event) {
    // Si el evento ya trae la cesta, se evita una petición.
    const desdeEvento =
      event?.detail?.cart?.item_count ?? event?.detail?.item_count;

    if (typeof desdeEvento === 'number') return render(desdeEvento);

    try {
      const res = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      render((await res.json()).item_count);
    } catch {
      // Sin red se deja el último estado conocido: mejor un número viejo que
      // hacer desaparecer la cesta de alguien que sí tiene piezas dentro.
    }
  }

  document.addEventListener('cart:update', sync);
  document.addEventListener('cart:refresh', sync);

  // El botón atrás puede servir la página desde la caché con el carrito ya
  // cambiado en otra pestaña.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) sync();
  });
}
